# Переключение между вкладками на странице
class window.PageSwitch
  constructor: ->
    @initPageSwitch()
    @activeSwitchClass = 'page-switch__option--active'
    @activeTabClass = 'page-switch__content-block--active'

  initPageSwitch: ->
    self = this
    $('.page-switch__option-button').each(
      ->
        unless $(this).attr("data-event-init") == "true"
          $(this).attr("data-event-init", "true") # вешаем на ссылку атрибут, не позволяющий повторно повешать на неё событие открытия

          $(this).click ->
            page_options = $(this).parents('.page-switch__block').find('.page-switch__option-button .page-switch__option')
            page_option_blocks = $(this).parents('.page-switch__block').find('.page-switch__content-block')
            selected_option = $(this)

            # Переключение кнопок
            page_options.removeClass(self.activeSwitchClass)
            selected_option.find('.page-switch__option').addClass(self.activeSwitchClass)

            # Переключение контента соответсвующего кнопке
            page_option_blocks.removeClass(self.activeTabClass)
            pageTab = selected_option.attr('data-tab-name') + '_tab'
            pageTab = $("##{pageTab}")
            pageTab.addClass(self.activeTabClass)
    )


// WEBPACK FOOTER //
// ./assets/javascripts/app/page_switch.coffee